
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Medullary_thyroid_carcinoma",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Medullary_thyroid_carcinoma.vue